import { CountryInput } from '../../lib/types/models/country/country-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateCountry(data: UpdateInput<CountryInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.countries.update.url, { id })).patch(rest)
}
